import React, { useContext, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { DrawerContext, Images, PermissionList, RolePermission } from 'utils';
import { leftBarCommonStyle } from './styles';

const billingSections = [
    RolePermission([PermissionList.CLAIMS_READ?.code, PermissionList.CLAIM_PMT_READ?.code, PermissionList.INVOICE_READ?.code]) && {
        label: 'Overview',
        path: '/overview',
        name: 'Billing',
    },

    RolePermission([
        PermissionList.CLAIMS_READ?.code,
        PermissionList.CLAIMS_CREATE?.code,
        PermissionList.CLAIMS_UPDATE?.code,
        PermissionList.CLAIMS_CLOSE?.code,
    ]) && {
        label: 'Claims',
        path: '/claims',
        name: 'Billing',
        detail: '/claims',
        multipleLinks: ['/claim', '/generateClaim'],
    },

    // RolePermission([PermissionList.CLAIMS_READ?.code]) && {
    //     label: 'Completed Claims',
    //     path: '/completed-claims',
    //     name: 'Billing',
    //     multipleLinks: ['/completedClaims', '/completed-claim'],
    // },

    RolePermission([
        PermissionList.CLAIM_PMT_READ?.code,
        PermissionList.CLAIM_PMT_PAY?.code,
        PermissionList.CLAIM_PMT_SEND_APPEAL?.code,
        PermissionList.CLAIM_PMT_APPEAL_READ?.code,
        PermissionList.CLAIM_PMT_APPEAL_PAY?.code,
    ]) && {
        label: 'Claim Payments',
        path: '/claimPayments',
        name: 'Billing',
        multipleLinks: ['/claimPayment', '/claim-payment'],
    },

    RolePermission([
        PermissionList.INVOICE_READ?.code,
        PermissionList.INVOICE_CREATE?.code,
        PermissionList.INVOICE_UPDATE?.code,
        PermissionList.INVOICE_CLOSE?.code,
    ]) && {
        label: 'Invoices',
        path: '/invoices',
        name: 'Billing',
        multipleLinks: ['/generateInvoice', '/invoice'],
    },
];

const payrollSections = [
    // RolePermission([PermissionList.TIMESHEET_READ.code]) &&
    { label: 'Timesheet', path: '/timesheet', name: 'Timesheet', multipleLinks: ['/timesheet'] },

    // RolePermission([PermissionList.TIMESHEET_READ.code]) &&
    // { label: 'Active', path: '/activePayroll', name: 'Payroll', multipleLinks: ['/timesheet'] },
    //
    // RolePermission([PermissionList.TIMESHEET_READ.code]) &&
    // { label: 'Processed', path: '/processedPayroll', name: 'Payroll', multipleLinks: ['/processed'] },
];

const analyticSections = [
    { label: 'Analytics', path: '/analytic', name: 'Reporting' },
    { label: 'Reports', path: '/report', name: 'Reporting' },
];

const settingsSections = [
    RolePermission([
        PermissionList.COMPANY_PROFILE_MANAGE.code,
        PermissionList.ROLES_READ.code,
        PermissionList.SYSTEM_SERVICE_TYPES?.code,
        PermissionList.SYSTEM_CREDENTIALS?.code,
        PermissionList.SYSTEM_DEPARTMENTS?.code,
        PermissionList.SYSTEM_JOB_TITLES?.code,
        PermissionList.SYSTEM_PAYCODE_TYPES?.code,
        PermissionList.SYSTEM_MILEAGE?.code,
        PermissionList.SYSTEM_OVERTIME?.code,
        PermissionList.SYSTEM_PLACE_OF_SERVICE?.code,
        PermissionList.MANAGE_INTEGRATIONS?.code,
    ]) &&
    { label: 'Practice', path: '/practice-settings', name: 'Settings' },
    RolePermission([PermissionList.DOMAIN_CREATE?.code, PermissionList.DOMAIN_READ?.code, PermissionList.SYSTEM_SERVICE_TYPES?.code]) &&
    { label: 'Clinical', path: '/clinical-settings', name: 'Settings' },
];

export const CustomAccordion = ({ item }) => {
    const linkInfo = window.location.pathname;
    const classes = leftBarCommonStyle();
    const accordionItems =
        item.name === 'Billing'
            ? billingSections
            : item.name === 'Payroll'
              ? payrollSections
              : item.name === 'Reporting'
                ? analyticSections
                : item.name === 'Settings'
                  ? settingsSections
                  : [];
    const { open, handleDrawerOpenClose } = useContext(DrawerContext);
    const [isShown, setIsShown] = useState(null);
    const [expand, setExpand] = useState(null);
    const location = useLocation();
    const originalPath = location?.pathname?.split('/')[1];
    const sectionsListClassName = `${classes.sectionsListBoxStyle} ${open && expand === item?.name ? 'shown' : ''}`;

    useEffect(() => {
        const findCurrent = accordionItems?.find((i) => i?.path === `/${originalPath}` || i?.multipleLinks?.includes(`/${originalPath}`));
        setIsShown(findCurrent);
        setExpand(findCurrent?.name);
    }, [originalPath]);

    function handleAccordionClick() {
        setExpand(item?.name !== expand ? item?.name : null);
        if (!open) {
            handleDrawerOpenClose(true);
        }
    }

    return (
        <div className="router-accordion-box">
            <div className={classes.linkPathWrapper} onClick={handleAccordionClick}>
                <div className={item?.name === isShown?.name ? classes.activeBorder : classes.passiveBorder} />
                <div
                    style={{ width: open ? '100%' : 'auto', borderRadius: open ? '4px 0px 0px 4px' : '4px' }}
                    className={`${classes.linkWrapper} ${item?.name === isShown?.name ? classes.linkWrapperActive : classes.linkWrapperPassive}`}
                >
                    <div className={classes.linkImageWrapper}>
                        <img src={item?.name === isShown?.name ? item?.activeIcon : item?.icon} alt="icon" />
                    </div>
                    {open && (
                        <>
                            <p>{item?.name}</p>
                            <div className={expand === item?.name || isShown?.name === item?.name ? '' : 'router-accordion-expand-icon'}>
                                <img
                                    className={`${classes.accordArrowStyle} 
                              ${expand === item?.name ? 'rotate' : ''}`}
                                    src={isShown?.name === item?.name ? Images.accordArrowBlue : Images.accordArrowBlack}
                                    alt="icon"
                                />
                            </div>
                        </>
                    )}
                </div>
            </div>
            <div className={sectionsListClassName}>
                <div>
                    {accordionItems?.map((section, index) => {
                        if (section) {
                            const path = section?.path;
                            const label = section?.label;
                            const hasSame = section?.multipleLinks?.includes(`/${originalPath}`);
                            const activeClassName = linkInfo === path || hasSame ? 'active' : '';

                            // console.log(activeClassName,'activeClassName');
                            return (
                                <NavLink onClick={() => setIsShown(item)} key={index} to={path} className={activeClassName}>
                                    {label}
                                </NavLink>
                            );
                        }
                    })}
                </div>
            </div>
        </div>
    );
};
